module.exports = __webpack_public_path__ + "static/media/report_menu_blue.83e23af0.svg";